import { useDropzone } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";
import exifr from "exifr";

function UploadDropzone({ onFilesAdded }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "image/*": [] },
    multiple: true,
    onDrop: async (acceptedFiles) => {
      const items = await Promise.all(
        acceptedFiles.map(async (file) => {
          const exif = await exifr.parse(file).catch(() => ({}));

          return {
            id: uuidv4(),
            file,
            previewUrl: URL.createObjectURL(file),
            exif,
            metadata: {},
            status: "pending",
            progress: 0,
          };
        })
      );

      onFilesAdded(items);
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #666",
        padding: "40px",
        textAlign: "center",
        cursor: "pointer",
        background: isDragActive ? "#222" : "transparent",
        color: "#aaa",
      }}
    >
      <input {...getInputProps()} />
      <p>Drag & drop photos here, or click to select</p>
    </div>
  );
}

export default UploadDropzone;